import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useAppStore } from "../../../../../../hooks/useStores.tsx";
import { TgDatasetImage } from "../../../../Datasets/store/tg-dataset-store.tsx";
import styles from "./TgDatasetSampleImageGrid.module.scss";

type Props = {
	sampleImages: TgDatasetImage[];
};

const TgDatasetSampleImageGrid = ({ sampleImages }: Props) => {
	const { t } = useTranslation("tg", { keyPrefix: "models.create.captioning" });
	const { tgStore } = useAppStore();
	const { tgDatasetStore } = tgStore;

	const isAdvancedDataset = tgDatasetStore.datasetForm.upload_type === "advanced";

	return (
		<Box className={styles.container}>
			<Typography className={styles.title}>{t("sampledTrainingImagesTitle")}</Typography>

			<Box className={styles.grid}>
				{isAdvancedDataset && tgDatasetStore.advancedDatasetImages.sample_training_images.length !== 0
					? tgDatasetStore.advancedDatasetImages.sample_training_images.map((base64, idx) => (
							<Box key={idx} className={styles.tile}>
								<img src={`data:image/*;base64,${base64}`} />
							</Box>
						))
					: sampleImages.slice(0, 6).map((img) => (
							<Box key={img.id} className={styles.tile}>
								<img src={img.thumbnail_url || img.image_url} />
							</Box>
						))}
			</Box>
		</Box>
	);
};

export default observer(TgDatasetSampleImageGrid);
